<template>
  <div style="height: 100%">
    <grid
      ref="grid"
      :config="gridConfig"
      class="no-grid-border"
    />
  </div>
</template>

<script>
import gridConfig from './GridConfig.js'
import { waitValue } from '@/utils/promises'

export default {
  name: 'StocksParts',
  components: {
    'grid': () => import(/* webpackChunkName: 'Grid' */ '@/components/Grid/Index')
  },
  props: {
    partID: { required: true }
  },
  watch: {
    'partID': {
      immediate: true,
      handler () {
        this.getGrid()
          .then((grid) => {
            if (this.partID) {
              grid.setFilters(`partID == ${this.partID}`)
              grid.loadData()
            }
          })
      }
    }
  },
  data () {
    return {
      gridConfig: gridConfig
    }
  },
  methods: {
    getGrid () {
      return waitValue(() => this.$refs.grid)
    }
  }
}
</script>
